export default [
	{
		dataIndex: 'code',
		key: 'productCode',
		title: 'Code',
		scopedSlots: {customRender: 'productCode'}
	}, {
		dataIndex: 'name',
		key: 'productName',
		width: 400,
		title: 'Name',
		scopedSlots: {customRender: 'productName'}
	}, {
		dataIndex: 'price',
		key: 'basePrice',
		title: 'Base Price',
		scopedSlots: {customRender: 'basePrice'}
	}, {
		dataIndex: 'admin_fee',
		key: 'adminFee',
		title: 'Admin Fee',
		scopedSlots: {customRender: 'adminFee'}
	}, {
		dataIndex: 'share_fee',
		key: 'shareFee',
		title: 'Share Fee',
		scopedSlots: {customRender: 'shareFee'}
	}, {
		key: 'status',
		title: "Status",
		width: 150,
		scopedSlots: { customRender: 'status' }
	}, {
		key: 'action',
		title: '',
		width: 200,
		align: 'right',
		scopedSlots: {customRender: 'action'}
	}
]
